import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Expenses from './pages/Expenses';
import ExpenseDetail from './pages/ExpenseDetail';
import Upload from './pages/Upload';
import Export from './pages/Export';
import Eligibility from './pages/Eligibility';
import Settings from './pages/Settings';
import Payments from './pages/Payments';
import ReviewedImport from './pages/ReviewedImport';
import Layout from './components/Layout';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return (
            <div className="loading-screen">
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <Layout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Dashboard />} />
                        <Route path="expenses" element={<Expenses />} />
                        <Route path="expenses/:id" element={<ExpenseDetail />} />
                        <Route path="upload" element={<Upload />} />
                        <Route path="payments" element={<Payments />} />
                        <Route path="reviewed-import" element={<ReviewedImport />} />
                        <Route path="eligibility" element={<Eligibility />} />
                        <Route path="export" element={<Export />} />
                        <Route path="settings" element={<Settings />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
